import type { ToolMeta } from './registry';

export const planningSnapshotMeta = {
  description:
    "Returns a structured snapshot of the couple's planning state — budget, checklist, guests, suppliers, and events.",
  examples: [
    'Give me a full status update on my wedding',
    'What does my budget look like?',
    'How many guests have I added so far?',
  ],
  value: 'where their plan stands right now',
} as const satisfies ToolMeta;
